/** Alle Oberflächentexte (A1: Deutsch über eine i18n-Datei). */
export const de = {
  screenshare: {
    start: 'Bildschirm teilen',
    stop: 'Freigabe beenden',
    cancel: 'Freigabe abbrechen',
    title: 'Bildschirmfreigaben',
    yours: 'Dein Bildschirm',
    by: 'Bildschirm von {name}',
    expand: 'Bildschirm vergrößern',
    close: 'Große Ansicht schließen',
    cancelled: 'Bildschirmfreigabe abgebrochen oder nicht erlaubt. Du kannst sie jederzeit erneut starten.',
    unsupported: 'Dieser Browser unterstützt keine Bildschirmfreigabe.',
    failed: 'Der Bildschirm konnte nicht geteilt werden. Bitte versuch es erneut.',
    audioHint: 'Ton wird mitgeteilt, wenn du ihn im Browserdialog freigibst.',
  },
  availability: {
    title: 'Verfügbarkeit',
    available: 'Verfügbar',
    away: 'Abwesend',
    dnd: 'Nicht stören',
    availableHint: 'Gespräche in deiner Nähe sind möglich.',
    awayHint: 'Du bleibst sichtbar. Mikrofon, Kamera und Gespräche pausieren.',
    dndHint: 'Keine Audio- oder Videogespräche. Chat bleibt erreichbar.',
    pausedHint: 'Beim Zurückkehren bleiben Mikrofon und Kamera aus.',
    mediaPaused: 'Audio und Video sind pausiert.',
  },
  app: {
    name: 'Flurfunk',
    tagline: 'Euer virtuelles Büro',
    noSpace: 'Öffne den Einladungslink deines Teams, um den Flurfunk zu betreten.',
  },
  login: {
    title: 'Willkommen im {space}',
    titleUnknown: 'Willkommen im Flurfunk',
    password: 'Passwort',
    name: 'Dein Name',
    namePlaceholder: 'So sehen dich die anderen',
    submit: 'Eintreten',
    submitting: 'Einen Moment …',
    hint: 'Dieses Gerät wird wiedererkannt. Beim nächsten Mal bist du sofort drin.',
    errors: {
      WRONG_PASSWORD: 'Das Passwort stimmt nicht.',
      RATE_LIMIT: 'Zu viele Versuche. Bitte warte {seconds} Sekunden.',
      SPACE_NOT_FOUND: 'Diesen Space gibt es nicht. Prüfe den Link.',
      INVALID_NAME: 'Bitte gib einen Namen mit 1 bis 40 Zeichen ein.',
      NETWORK: 'Der Server ist gerade nicht erreichbar.',
      generic: 'Das hat nicht geklappt. Bitte versuch es noch einmal.',
    },
    sessionExpired: 'Deine Sitzung ist abgelaufen. Bitte melde dich neu an.',
  },
  avatar: {
    title: 'Wie sollen dich die anderen sehen?',
    titleEdit: 'Avatar ändern',
    quickstart: 'Schnellstart',
    save: 'Los geht’s',
    saveEdit: 'Fertig',
    cancel: 'Abbrechen',
    color: 'Farbe',
    categories: 'Kategorien',
    remove: 'entfernen',
    noneHint: 'Nichts gewählt – klick ein Teil an.',
    turn: 'Drehen',
    walk: 'Laufen',
    credits: 'Figuren:',
    saveFailed: 'Der Avatar konnte nicht gespeichert werden.',
    slots: {
      body: 'Haut',
      eyes: 'Augen',
      hair: 'Haare',
      outfit: 'Outfit',
      hat: 'Kopfbedeckung',
      face: 'Gesicht',
      extra: 'Extras',
    },
  },
  space: {
    loading: 'Büro wird geladen …',
    connecting: 'Verbinde …',
    reconnecting: 'Verbindung wird wiederhergestellt …',
    offline: 'Keine Verbindung zum Büro. Neuer Versuch läuft …',
    replaced: 'Flurfunk ist in einem anderen Fenster geöffnet. Dieses Fenster ist getrennt.',
    kicked: 'Die Verbindung wurde vom Server getrennt.',
    rejoin: 'Hier weitermachen',
    mapError: 'Das Büro konnte nicht geladen werden.',
    retry: 'Erneut versuchen',
    logout: 'Abmelden',
  },
  media: {
    micOn: 'Mikrofon an',
    micOff: 'Mikrofon aus',
    camOn: 'Kamera an',
    camOff: 'Kamera aus',
    devices: 'Geräte',
    microphone: 'Mikrofon',
    camera: 'Kamera',
    speaker: 'Lautsprecher',
    defaultDevice: 'Standard',
    denied: 'Der Browser hat den Zugriff auf {device} verweigert. Erlaube ihn in den Seiteneinstellungen.',
    busy: '{device} wird gerade von einem anderen Programm benutzt.',
    notFound: 'Kein {device} gefunden.',
    failed: '{device} konnte nicht gestartet werden.',
    unavailable: 'Video und Audio sind gerade nicht verfügbar. Der Flur funktioniert trotzdem.',
    reconnecting: 'Video verbindet neu …',
    enableAudio: 'Ton aktivieren',
    audioBlocked: 'Der Browser hat den Ton blockiert.',
    you: 'Du',
    connecting: 'verbindet …',
  },
  chat: {
    title: 'Chat',
    nearby: 'In der Nähe',
    all: 'Alle',
    placeholderNearby: 'Nachricht an die Leute in deiner Nähe',
    placeholderAll: 'Nachricht an alle',
    send: 'Senden',
    emptyNearby: 'Hier landen Nachrichten an alle, die gerade in deiner Nähe stehen. Sie werden nicht gespeichert.',
    emptyAll: 'Noch keine Nachrichten.',
    rateLimit: 'Langsam! Höchstens 5 Nachrichten in 5 Sekunden.',
    nobodyNear: 'Gerade ist niemand in deiner Nähe.',
    inRoom: 'Du bist in {room}: Nachrichten hier erreichen alle im Raum und niemanden draußen.',
  },
  controls: {
    chat: 'Chat',
    people: 'Personen',
    avatar: 'Avatar',
    zoomIn: 'Näher heran',
    zoomOut: 'Weiter weg',
    closePanel: 'Seitenleiste schließen',
  },
  area: {
    meeting: 'Meetingraum',
    private: 'privat',
    privateHint: 'Nur wer hier drin ist, hört und sieht euch.',
    occupancy: '{count}/{capacity}',
    people: '{count} hier',
  },
  desk: {
    free: 'frei',
    claim: 'Platz nehmen',
    claimed: 'Das ist jetzt dein Platz.',
    mine: 'Mein Platz',
    goto: 'Zu meinem Platz',
    gotoKey: 'Strg+D',
    decorate: 'Platz einrichten',
    decorateRoom: 'Teamraum einrichten',
    release: 'Platz freigeben',
    none: 'Du hast noch keinen Platz. Klick im Büro auf ein „frei“-Schild.',
    owner: 'Platz von {name}',
    teamOnly: 'Dieser Platz gehört zu einem anderen Team.',
    taken: 'Dieser Platz ist schon vergeben.',
    decorTitle: 'Platz einrichten',
    decorTable: 'Tisch',
    decorChair: 'Stuhl',
    decorParts: 'Deko wählen',
    decorStyleHint: 'Tisch und Stuhl auswählen. Die Zahl oben zählt deine gesetzten Teile, nicht die Auswahl im Katalog. Die Vorschau ist nur für dich sichtbar, bis du speicherst.',
    deskColors: { light: 'Hell', grey: 'Grau', dark: 'Dunkel' },
    chairColors: { black: 'Schwarz', orange: 'Orange' },
    decorHint: 'Teil wählen, dann im markierten Bereich klicken. PC, Tastatur, Maus und Tasse direkt auf die Tischplatte setzen. Klick auf ein gesetztes Teil entfernt es.',
    decorSave: 'Fertig',
    decorCancel: 'Abbrechen',
    decorLimit: 'Höchstens {max} Teile.',
    decorOutside: 'Nur im markierten Bereich.',
    decorOverlap: 'Da steht schon etwas.',
    decorSurface: 'Setze diesen Gegenstand auf eine freie Tischfläche.',
    decorBlocks: 'Das würde einen Weg versperren.',
    decorSaved: 'Dein Platz ist eingerichtet.',
    decorRate: 'Zu viele Änderungen hintereinander – bitte kurz warten.',
    decorInvalid: 'Das ließ sich so nicht speichern. Prüfe die Teile im markierten Bereich.',
    decorLocked: 'Das Büro wird gerade im Studio bearbeitet. Deine Auswahl bleibt erhalten. Bitte versuche das Speichern gleich noch einmal.',
    corridor: 'Flur',
    released: 'Dein Platz ist wieder frei.',
    yours: 'Das ist dein Platz.',
    freeHere: 'Dieser Platz ist frei.',
  },
    roomEditor: {
      title: 'Teamraum einrichten',
      room: 'Raum wählen',
      hint: 'Möbel anklicken und ziehen. Überlappungen sind erlaubt. Die Raumgrenzen und Wände bleiben bestehen.',
      navigation: 'Mausrad: Zoom · Leertaste und Ziehen: Ansicht verschieben · Pfeiltasten: Auswahl verschieben · Entf: entfernen',
      placement: 'Im Raum klicken, um das Möbel abzusetzen. Enter setzt es in die Bildmitte. Escape beendet das Einfügen.',
      count: '{count}/{max} Möbel und Plätze im Raum',
      objects: 'Im Raum',
      selection: 'Ausgewähltes Möbel',
      type: 'Möbel wechseln',
      remove: 'Entfernen',
      assigned: 'Dieser Platz ist vergeben. Du kannst ihn verschieben und gestalten; freigeben kann ihn sein Besitzer oder ein Admin.',
      fit: 'Ganzen Raum zeigen',
      zoomIn: 'Vergrößern',
      zoomOut: 'Verkleinern',
      undo: 'Rückgängig',
      redo: 'Wiederholen',
      rotate: 'Drehen',
      save: 'Raum speichern',
      cancel: 'Abbrechen',
      discard: 'Änderungen verwerfen',
      saving: 'Wird gespeichert …',
      invalid: 'Das Möbel muss ganz in diesem Raum bleiben. Tischzubehör braucht eine Tischplatte; vergebene Plätze bleiben erhalten.',
      empty: 'Für dich ist noch kein Teamraum zum Einrichten verfügbar.',
      switchHint: 'Vor dem Raumwechsel Änderungen speichern oder verwerfen.',
      reload: 'Aktuellen Raumstand laden',
      conflict: 'Der Raum wurde inzwischen geändert. Dein Entwurf bleibt offen. Lade den aktuellen Stand, bevor du weiterarbeitest.',
      saved: 'Der Teamraum wurde gespeichert.',
    },
    people: {
    title: 'Personen',
    online: '{count} im Büro',
    you: '(du)',
    reconnecting: 'verbindet neu',
    near: 'in der Nähe',
    offline: 'offline',
    noTeam: 'Ohne Team',
    goto: 'Hingehen',
    inArea: 'in {area}',
    atDesk: 'Platz',
    search: 'Person suchen',
    offlineCount: '{count} offline',
  },
  admin: {
    becomeTitle: 'Admin-Zugang',
    becomeHint: 'Mit dem Admin-Passwort deines Teams kannst du Büro, Teams und Plätze verwalten.',
    password: 'Admin-Passwort',
    submit: 'Freischalten',
    done: 'Du bist jetzt Admin.',
    wrong: 'Das Admin-Passwort stimmt nicht.',
  },
  more: {
    title: 'Mehr',
    admin: 'Admin-Zugang',
    studio: 'Büro bearbeiten (Studio)',
    sprintTip: 'Tipp: Umschalttaste halten, um zu sprinten. Strg+D bringt dich zu deinem Platz.',
  },
  errors: {
    RATE_LIMIT: 'Zu viele Nachrichten – kurz warten.',
    FLOOD: 'Zu viele ungültige Nachrichten. Verbindung getrennt.',
    INVALID_AVATAR: 'Dieser Avatar ist ungültig.',
    generic: 'Etwas ist schiefgelaufen.',
  },
} as const;
